import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";

import axios from "axios";
import { globalConfig } from "../../../config/config";
import { useContentObjectContext } from "../contexts/ContentObjectContext";
// const querystring = require("querystring");
const CreateContentApplication = () => {
  const [message, setMessage] = useState("");
  const { currentContentObject } = useContentObjectContext();
  const {token,userMetadata}=useAuth()
  const history = useHistory();
  const [state, setState] = useState({
    contentApplicationId: 0,
    contentApplicationName: "",
    contentApplicationUrl: "",
    contentApplicationVendor: 0,
    contentApplicationVersion: "",
    securityContextId: 0,
    lastUpdateUser: 0,
    lastUpdateDate: new Date(),
    contentId: currentContentObject,
  });
  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }
  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");

    var url = `${globalConfig.apiDatahubUrl}/content-applications`;
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/content-applications/contentApplicationId`;

    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentApplicationId = response.data["nextId"];

      //console.log("new category id = " + JSON.stringifyt(this.state.contentCategoriesObject.contentCategoryId));

      console.log("request object = " + JSON.stringify(state));
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(
            response2.status + ":" + response2.data.contentApplicationId
          );
          // && response2.data.contentFacadeId === this.state.contentFacadeId
          if (response2.status === 200) {
            setMessage("Success");
          } else {
            setMessage("Failed");
          }
          console.log(message);
          //
          event.preventDefault();
          //response.send(this.message);
        })
        .catch((err) => {
          console.log("error - " + err);
        });
      console.log("message info - " + message);
      setState({
        ...state,
        contentApplicationName: "",
        contentObjectName: "",
        contentApplicationUrl: "",
        contentApplicationVersion: "",
      });
    });
  }
  function handleRest(event) {
    setState({
      ...state,
      contentApplicationName: "",
      contentObjectName: "",
      contentApplicationUrl: "",
      contentApplicationVersion: "",
    });
    //   this.contentObjectName = "";
  }

  const handleOnLoad = () => {};
  return (
    <form>
      <div className="container-fluid">
        <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => history.goBack()}
        >
          Go Back
        </button>
        <h4>Create Content Application</h4>
        <hr />
        <div className="form-group row">
          <label value="Application" className="ContentTitle col-sm-2">
            Application
          </label>
          <input
            id="contentApplicationName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentApplicationName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label value="Content Object Name" className="ContentTitle col-sm-2">
            {" "}
            Content Object Name
          </label>
          <input
            className="form-control input-xlarge col-sm-8"
            id="content_name"
            readOnly={true}
            value={state.contentId}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label value="Application URL" className="ContentTitle col-sm-2">
            Application URL
          </label>
          <input
            id="contentApplicationUrl"
            className="form-control input-xlarge col-sm-8"
            value={state.contentApplicationUrl}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label value="Version" className="ContentTitle col-sm-2">
            Version
          </label>
          <input
            id="contentApplicationVersion"
            className="form-control input-xlarge col-sm-8"
            value={state.contentApplicationVersion}
            onChange={handleChange}
          />
        </div>
        <hr />
        <button className="btn btn-primary" value="Clear" onClick={handleRest}>
          {" "}
          Clear
        </button>
        &nbsp;
        <button
          className="btn btn-success "
          value="Create"
          onClick={handleSubmit}
        >
          {" "}
          Create
        </button>
      </div>
    </form>
  );
};

export default CreateContentApplication;
